var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-button',{staticClass:"button--close",attrs:{"icon":"cross","colour":_vm.colour,"size":_vm.size,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }